import { render } from "./ProjectShowcase.vue?vue&type=template&id=fd6df354"
import script from "./ProjectShowcase.vue?vue&type=script&lang=js"
export * from "./ProjectShowcase.vue?vue&type=script&lang=js"

import "./ProjectShowcase.vue?vue&type=style&index=0&id=fd6df354&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__